import type { BrandInsightsPageContext } from '@trinity/chat';
import { ChatContextType, isEverythingContext } from '@trinity/chat';

export function shouldShowLandingCardsAfterReset(
  context: BrandInsightsPageContext.Item | null | undefined
): boolean {
  if (!context) {
    return false;
  }

  return (
    context.type === ChatContextType.Global ||
    isEverythingContext(context) ||
    (context.type === ChatContextType.Agent && context.data.showLandingCardsOnNewChat)
  );
}
